import {
  IUseHistoryOfViewStageResponse,
  tableViewScheduleStage,
  viewSchedule,
  viewStage,
} from './models/types';

export const useHistoryOfViewStage = (): IUseHistoryOfViewStageResponse => {
  const viewStageHistoryName = 'viewStageHistory';
  const viewScheduleHistoryName = 'viewScheduleHistory';
  const tableViewScheduleStageHistoryName = 'tableViewScheduleStageHistory';

  const getViewStageHistory = (): viewStage | null => {
    const viewStage = localStorage.getItem(viewStageHistoryName);
    return viewStage as viewStage;
  };

  const getViewScheduleHistory = (): viewSchedule | null => {
    const viewSchedule = localStorage.getItem(viewScheduleHistoryName);
    return viewSchedule as viewSchedule;
  };
  const getTableViewScheduleStageHistory =
    (): tableViewScheduleStage | null => {
      const viewSchedule = localStorage.getItem(
        tableViewScheduleStageHistoryName,
      );
      return viewSchedule as tableViewScheduleStage;
    };

  const setViewStageHistory = (viewStage: viewStage) => {
    localStorage.setItem(viewStageHistoryName, viewStage);
  };
  const setViewScheduleHistory = (viewSchedule: viewSchedule) => {
    localStorage.setItem(viewScheduleHistoryName, viewSchedule);
  };
  const setTableViewScheduleStageHistory = (
    tableViewScheduleStage: tableViewScheduleStage,
  ) => {
    localStorage.setItem(
      tableViewScheduleStageHistoryName,
      tableViewScheduleStage,
    );
  };

  return {
    getViewStageHistory,
    getViewScheduleHistory,
    setViewStageHistory,
    setViewScheduleHistory,
    getTableViewScheduleStageHistory,
    setTableViewScheduleStageHistory,
  };
};
